module.exports = __webpack_public_path__ + "static/fortona-963baecf1d64fec922eb71f68aa04686.png";